/**
 * Graphic GIERMEK wordmark used in page headers.
 *
 * The image is decorative and carries no alt text: the accessible name comes
 * from the screen-reader-only wordmark next to it, so the brand is announced
 * once rather than twice.
 */

import { BrandName } from './BrandName'

interface BrandLogoProps {
  /** Height utilities for the image, e.g. "h-8 md:h-10". */
  className?: string
}

export function BrandLogo({ className = 'h-8' }: BrandLogoProps) {
  return (
    <span className="inline-flex items-center">
      <img src="/assets/logo/logo-napis.webp" alt="" className={`${className} w-auto`} />
      <span className="sr-only">
        <BrandName />
      </span>
    </span>
  )
}
